
export default {
  SET_NEXT_SEQ_CODE: (state, payload) => state.nextSeqCode = payload,
  
  SET_VESSEL: (state, payload) => state.vessel = payload,
  SET_VESSELS: (state, payload) => state.vessels = payload,

  SET_VESSEL_NAMES: (state, payload) => {
    state.vesselNames = payload;
    (payload || []).forEach(v => state.vesselsMap[v.Id] = v.Name)

    let data = Object.assign([], payload);
    state.vesselsFilterData = data;
  }
}